import React from "react";
import { AuthContext } from "./AuthContext";
import useStateWithLocalStorage from "../hooks/useStateWithLocalStorage";
import { API_ENDPOINTS } from "../config/api";
import { apiPost } from "../utils/apiClient";

const podiumAuthProvider = {
  async login(
    email: string,
    password: string,
    callback: (success: Boolean, data?: any) => void,
  ) {
    try {
      const response = await apiPost<{ data: { user: any } }>(
        API_ENDPOINTS.login,
        { user: { email, password } },
        { includeMetadata: true, skipLeagueHeader: true },
      );

      const token = response.headers.get("Authorization");

      callback(true, {
        user: response.data.data.user,
        token,
      });
    } catch (error) {
      console.error("An error occurred while logging in", error);
      // Check if it's a 401 error (invalid credentials)
      const errorMessage =
        error instanceof Error && error.message === "Unauthorized"
          ? "Invalid Login"
          : error instanceof Error
            ? error.message
            : "An error occurred";
      callback(false, errorMessage);
    }
  },
  logout(callback: VoidFunction) {
    // TODO: call api endpoint
    callback();
  },
};

function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useStateWithLocalStorage<any>("user", {});
  const [token, setToken] = useStateWithLocalStorage<string>("token", "");

  let login = (
    email: string,
    password: string,
    callback: (success: Boolean, errorMessage?: string) => void,
  ) => {
    return podiumAuthProvider.login(email, password, (success, data?) => {
      if (success && typeof data !== "undefined") {
        setUser(data.user);
        setToken(data.token);
      } else {
        setUser({});
        setToken("");
      }
      callback(success, data);
    });
  };

  let logout = (callback: VoidFunction) => {
    return podiumAuthProvider.logout(() => {
      setUser({});
      setToken("");
      callback();
    });
  };

  let isAuthenticated = () => typeof token !== "undefined" && token.length > 0;
  let isAdmin = () => true;

  let value = { user, token, login, logout, isAuthenticated, isAdmin };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
